export default {
  type: 'Typ',
  all: 'Wszystkie',
  analysis: 'Analiza materiału',
  specification: 'Specyfikacja materiału',
  analysisList: 'Analizy materiału',
};
